import * as ko from "knockout";
import {ICompany} from "../../../../../index";
import {UPDATING_MESSAGE} from "../../../../../constants/Language";
import {global} from "../../../../../appContext";
import {createErrorMessage} from "../../../../../util/misc";
import {nsDate} from "../../nsDate";
import {AbstractCard} from "../AbstractCard";
import {MutableImportFilterData} from "./MutableImportFilterData";
import {StatusManager} from "../../StatusManager";
import detailsHtml from './details.html?raw';

export const template = detailsHtml

export class viewModel extends AbstractCard {

    protected readonly Keys: (keyof ICompany)[] = [
        'ignoreimportfilter',
        'ignoreimportfilteruntil',
        'importfilterdeactivated',
        'importfilterdeactivatedby',
        'importfilterdeactivatedbyorgnr',
        'maxdeletes',
        'maxedit',
        'maxnew',
    ] as const

    protected override obj: MutableImportFilterData;

    constructor(statusManager: StatusManager) {
        super(statusManager)
        this.obj = this.statusManager.mutableImportFilter
    }

    readonly importFilterDeactivatedText = ko.pureComputed((): string | null => {
        const str = this.statusManager.mutableCompany.props.importfilterdeactivated?.()
        return str ? `sync.statuscards.deactivated|deactivateddate:${nsDate.getDate(str, true)}` : null
    })

    readonly showImportFilterDeactivatedMeta = ko.pureComputed(() => {
        if (this.obj.crudMode() !== 'read' || this.obj.isActive()) {
            return false
        }
        const p = this.statusManager.mutableCompany.props
        return !!(p.importfilterdeactivated?.() || p.importfilterdeactivatedby?.())
    })

    protected onSubmitClick() {
        return Promise.resolve()
            .then(() => {
                this.messageData({message: UPDATING_MESSAGE})
                this.statusManager.isSubmitting(true)
                this.updateProps()
            })
            .then(() => this.statusManager.mutableCompany.submit(this.Keys))
            .then(() => this.statusManager.do_getcompany())
            .then(() => this.statusManager.mutableCompany.init())
            .then(() => {
                global.snackbarData({message: 'sync.importfilter.message.success'})
                this.statusManager.removeCache('getcompany')
            })
            .then(() => this.statusManager.init())
            .catch((reason: string) => {
                this.statusManager.isSubmitting(false)
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    protected override onCancelClick() {
        this.messageData(null)
        this.obj.discard()
        this.updateProps()
    }

    private getInputClass(key: keyof ICompany) {
        return this.obj.isInputValid(key) ? '' : 'warning'
    }

}